import { Button, Form, FormInstance } from 'antd';
import DropdownIcon from 'assets/icons/simulate-dropdown.svg';
import { OptionEntity } from 'domain/entities/OptionEntity';
import { SimulateCashFlowEntity, SimulateCashFlowGetEntity } from 'domain/entities/SimulateEntity';
import SelectionDynamic from 'presentation/components/SelectionDynamic';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { TAX_RATE } from 'utilities/constants/COMMON';
import getMessage from 'utilities/constants/MESSAGE';
import { AlertModalProps } from 'presentation/components/Modal/Modal.type';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';
import { CONSTANTS } from 'utilities/constants/SIMULATE';
import { useLocation } from 'react-router-dom';
import { commonHelpers } from 'utilities/helpers';
import InputAllowNumber from '../../CU-010-01/components/Input';
import { showAlert } from 'presentation/redux/features/app/appSlice';
type props = {
  form: FormInstance;
  options: OptionEntity[];
  loanOption: OptionEntity[];
  onChangeSelect: (value: string) => void;
  fixedFeeAmount: number;
  feeRate: number;
  loanFinancialSelected: any;
  isDisalbleItem: boolean;
  getData(values?: SimulateCashFlowEntity): void;
  getCollapseProps(): any;
  onSave(values: SimulateCashFlowEntity): void;
  btnDisable: boolean;
  setBtnDisable(value: boolean): void;
  data?: SimulateCashFlowGetEntity;
  loanRefer: any;
};

const FormSimulateSale = ({
  form,
  options,
  loanOption,
  fixedFeeAmount,
  feeRate,
  getData,
  getCollapseProps,
  btnDisable,
  setBtnDisable,
  data,
  loanRefer,
}: props) => {
  const navigate = useNavigate();
  const simulatorConsumptionTaxRate = TAX_RATE.INCLUDE;
  const [thousand, setThousand] = React.useState<boolean>(true);
  const [feeString, setFeeString] = useState("2");
  const [feeValue, setFeeValue] = useState(0);
  const { search } = useLocation();
  const [rent, setRent] = useState(0);
  const [brokerageFee, setBrokerageFee] = useState(0);
  const [loanFinancialSelected, setLoanFinancialSelected] = useState<any>();
  const [isDisalbleItem, setDisalbleItem] = useState<boolean>(true);
  const location = useLocation();
  const state = location.state as { simId?: number };

  const simId = state?.simId; 
  useEffect(() => {
    if (data) {
      setRent(data.rent);
      setFeeString(
        commonHelpers.formatNumberMoney(
          Math.floor((Number(data.brokerageFee)))
        )
      );
      setFeeValue(data.brokerageFee || 0);
    }
  }, [data, feeRate, fixedFeeAmount, simulatorConsumptionTaxRate]);

  const onChangeSelect = (value: string) => {
    if (value == 'manual_settings') {
      setDisalbleItem(false);
    } else {
      setDisalbleItem(true);
    }
    const destination: any = loanRefer.find(
      (item: any) => item.loanFinancialInstitutionCode === value,
    );
    setLoanFinancialSelected(destination);
    form.setFieldsValue({
      interestRate: Number(destination?.interestRateLowerLimit),
      buildingAge: Number(destination?.buildingAgeCriteria),
      expense: commonHelpers.formatNumberMoney(Number(destination?.expenseLowerLimit)),
    });
  };

  const handleFee = (value: string) => {
    const calculatedFee = Math.floor((Number(value) * feeRate + fixedFeeAmount) * simulatorConsumptionTaxRate);

    setFeeValue(calculatedFee);
    setFeeString(commonHelpers.formatNumberMoney(calculatedFee));
    setBrokerageFee(calculatedFee);
  };

  const onChangeForm = () => {
    const objForm: any = form.getFieldsValue();
    if (objForm.personalFunds === undefined || objForm.personalFunds === '') setThousand(false);
    else setThousand(true);
    form.validateFields({
      validateOnly: true,
    })
      .then(() => {
        setBtnDisable(false);
      })
      .catch((err) => {
        setBtnDisable(err.errorFields.length > 0);
      });
  };

  const replace = (value: string) => {
    return value.replaceAll(',', '');
  };

  const scrollTop = () => {
    document.getElementById('top-page')?.scrollIntoView({ behavior: 'smooth' });
  };

  React.useEffect(() => {
    scrollTop();
  }, []);
  const onSubmit = async () => {
    scrollTop();
    const values = form.getFieldsValue();
    const destination: any = loanRefer.find(
      (item: any) => item.loanFinancialInstitutionCode === values.loanFinancialInstitutionCode,
    );
    const payload: SimulateCashFlowEntity = {
      purchasePrice: Number(replace(values.purchasePrice)),
      personalFunds: Number(replace(values.personalFunds)),
      repaymentPeriod: Number(values.repaymentPeriod),
      rent: Number(replace(values.rent)),
      commonServiceFee: Number(replace(values.commonServiceFee)),
      managementFee: Number(replace(values.managementFee)),
      reserveFundForRepairs: Number(replace(values.reserveFundForRepairs)),
      loanFinancialInstitutionCode: values.loanFinancialInstitutionCode,
      periodStartDate: destination?.periodStartDate,
      interestRate: Number(values.interestRate),
      buildingAge: Number(values.buildingAge),
      expense: Number(replace(values.expense)),
      otherExpenses: values.otherExpenses ? Number(replace(values.otherExpenses)) : 0,
      manualCheck: false,
      includeBrokerageFee: false,
      simId: 0
    };
    getData(payload);
  };

  const gotoCu01501 = () => {
    const queryParams = new URLSearchParams(search);
    const param = {
      listedPropertyId:queryParams.get('listedPropertyId'),
      purchasePrice: queryParams.get('purchasePrice') || "",
      purchaseOfferId: queryParams.get('purchaseOfferId') || "",
      procedureId: queryParams.get('procedureId') || "",
      loanUseStatus: queryParams.get('loanUseStatus') || "",
    };
    navigate(
      `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_015_01}?${commonHelpers.generateQueryString(param)}`,
    );
  };

  const itemRules = {
    purchasePrice: [
      {
        required: true,
        message: getMessage('In_Required', '購入価格'),
      },
    ],
    personalFunds: [
      {
        required: true,
        message: getMessage('In_Required', '自己資金'),
      },
    ],
    repaymentPeriod: [
      {
        required: true,
        message: getMessage('In_Required', '返済期間'),
      },
    ],
    rent: [
      {
        required: true,
        message: getMessage('In_Required', '家賃'),
      },
    ],
        commonServiceFee: [
            {
              required: true,
              validator: (_: any, value: any) => {
                let sanitizedValue = value?.includes?.(',') ? value.replace(/,/g, '') : value;
                sanitizedValue = sanitizedValue == '' ? 0 : sanitizedValue;
                const isValid =
                  sanitizedValue !== undefined &&
                  sanitizedValue !== null &&
                  sanitizedValue !== '' &&
                  !isNaN(sanitizedValue) &&
                  Number(sanitizedValue) >= 0;
          
                return isValid
                  ? Promise.resolve()
                  : Promise.reject(new Error(getMessage('In_Required', '共益費')));
              },
            },
          ],
    managementFee: [
      {
        required: true,
        message: getMessage('In_Required', '管理費'),
      },
    ],
    reserveFundForRepairs: [
      {
        required: true,
        message: getMessage('In_Required', '修繕積立金'),
      },
    ],
    otherExpenses: [
      {
        required: false,
        message: getMessage('', 'その他費用'),
      },
    ],
    loanFinancialInstitutionCode: [
      {
        required: true,
        message: getMessage('In_Required', '金融機関'),
      },
    ],
    interestRate: [
      {
        required: false,
        message: getMessage('In_Required', '金利'),
      },
    ],
    buildingAge: [
      {
        required: false,
        message: getMessage('In_Required', '築年数基準'),
      },
    ],
    expense: [
      {
        required: false,
        message: getMessage('In_Required', '諸経費'),
      },
    ],
  };
  return (
    <div className="section-wrapper">
      <div className="simulate-form">
        <Form form={form} onValuesChange={onChangeForm} onFinish={onSubmit}>
          <div {...getCollapseProps()}>
            <div className="simulate-form-item">
              <div className="simulate-form-input">
                <InputAllowNumber
                  disabled={true}
                  placeholder={PLACEHOLDER.PURCHASE_PRICE}
                  defaultValue={data?.purchasePrice !== undefined && form.getFieldValue('purchasePrice') !== undefined && String(data.purchasePrice) === replace(form.getFieldValue('purchasePrice')) ? String(data.purchasePrice - feeValue) : ''}
                  suffix={'円'}
                  style={{
                    width: CONSTANTS.INPUT_WIDTH,
                    height: CONSTANTS.INPUT_HEIGHT,
                    border: CONSTANTS.INPUT_BORDER,
                    color: '#000',
                    fontSize: 14,
                  }}
                  name="purchasePrice"
                  maxLength={9}
                  min={0}
                  callback={handleFee}
                  rules={itemRules.purchasePrice}
                  label="購入価格"
                />
              </div>
              <div className="simulate-form-input">
                <InputAllowNumber
                  placeholder={PLACEHOLDER.PERSONAL_FUNDS_THOUSAND}
                  defaultValue={data?.personalFunds !== undefined && form.getFieldValue('personalFunds') !== undefined && String(data.personalFunds) === replace(form.getFieldValue('personalFunds')) ? String(data.personalFunds) : ''}
                  suffix={
                    <span>
                      {!thousand ? (
                        <span style={{ color: '#8D9AB4' }}>1</span>
                      ) : null}
                      00,000円
                    </span>
                  }
                  style={{
                    width: CONSTANTS.INPUT_WIDTH,
                    height: CONSTANTS.INPUT_HEIGHT,
                    border: CONSTANTS.INPUT_BORDER,
                    color: '#000',
                    fontSize: 14,
                  }}
                  name="personalFunds"
                  maxLength={7}
                  min={0}
                  rules={itemRules.personalFunds}
                  label="自己資金"
                />
              </div>
            </div>
            <div className="simulate-form-item">
              <div className="simulate-form-input">
                <span>
                  返済期間<span style={{ color: '#EB5757' }}>*</span>
                </span>

                <SelectionDynamic
                  style={{
                    width: CONSTANTS.INPUT_WIDTH,
                  }}
                  icon={<img src={DropdownIcon} alt="dropdown icon" />}
                  options={options}
                  defaultValue={String(form.getFieldValue('repaymentPeriod') ?? '')}
                  name="repaymentPeriod"
                />
              </div>
              <div className="simulate-form-input">
                <div className="simulate-form-desc">
                  <div className="simulate-form-desc__unit">
                    <div className="simulate-form-desc__unit-text">
                      仲介手数料
                    </div>
                    <div className="simulate-form-desc__unit-amount">
                      <span>{feeString}</span> &nbsp;円
                    </div>
                  </div>
                  <div className="simulate-form-desc__unit">
                    <div className="simulate-form-desc__unit-text">
                      <div>上記の仲介手数料がかかります。<br />仲介手数料は購入価格に組み込むこともできます。<br />詳しくはメッセージでご相談ください。</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="simulate-form-item">
              <div className="simulate-form-input">
                <InputAllowNumber
                  disabled={true}

                  placeholder={PLACEHOLDER.RENT}
                  defaultValue={data?.rent !== undefined && form.getFieldValue('rent') !== undefined && String(data.rent) === replace(form.getFieldValue('rent')) ? String(rent) : ''}
                  suffix={'円'}
                  style={{
                    width: CONSTANTS.INPUT_WIDTH,
                    height: CONSTANTS.INPUT_HEIGHT,
                    border: CONSTANTS.INPUT_BORDER,
                    color: '#000',
                    fontSize: 14,
                  }}
                  name="rent"
                  maxLength={7}
                  min={0}
                  rules={itemRules.rent}
                  label="家賃（収入）"
                />
              </div>
              <div className="simulate-form-input">
                <InputAllowNumber
                  disabled={true}

                  placeholder={PLACEHOLDER.COMMON_SERVICE_FEE}
                  defaultValue={
    data?.commonServiceFee !== undefined && form.getFieldValue('commonServiceFee') !== undefined && String(data.commonServiceFee) === replace(form.getFieldValue('commonServiceFee')) ? String(data.commonServiceFee): ''}
                  suffix={'円'}
                  style={{
                    width: CONSTANTS.INPUT_WIDTH,
                    height: CONSTANTS.INPUT_HEIGHT,
                    border: CONSTANTS.INPUT_BORDER,
                    color: '#000',
                    fontSize: 14,
                  }}
                  name="commonServiceFee"
                  maxLength={7}
                  min={0}
                  rules={itemRules.commonServiceFee}
                  label="共益費（収入）"
                />
              </div>
            </div>
            <div className="simulate-form-item">
              <div className="simulate-form-input">
                <InputAllowNumber
                  disabled={true}

                  placeholder={PLACEHOLDER.MANAGEMENT_FEE}
                  defaultValue={data?.managementFee !== undefined && form.getFieldValue('managementFee') !== undefined && String(data.managementFee) === replace(form.getFieldValue('managementFee')) ? String(data.managementFee) : ''}
                  suffix={'円'}
                  style={{
                    width: CONSTANTS.INPUT_WIDTH,
                    height: CONSTANTS.INPUT_HEIGHT,
                    border: CONSTANTS.INPUT_BORDER,
                    color: '#000',
                    fontSize: 14,
                  }}
                  name="managementFee"
                  maxLength={7}
                  min={0}
                  rules={itemRules.managementFee}
                  label="管理費（支出）"
                />
              </div>
              <div className="simulate-form-input">
                <InputAllowNumber
                  disabled={true}

                  placeholder={PLACEHOLDER.RESERVE_FUND_FOR_REPAIRS}
                  defaultValue={data?.reserveFundForRepairs !== undefined && form.getFieldValue('reserveFundForRepairs') !== undefined && String(data.reserveFundForRepairs) === replace(form.getFieldValue('reserveFundForRepairs')) ? String(data.reserveFundForRepairs) : ''}
                  suffix={'円'}
                  style={{
                    width: CONSTANTS.INPUT_WIDTH,
                    height: CONSTANTS.INPUT_HEIGHT,
                    border: CONSTANTS.INPUT_BORDER,
                    color: '#000',
                    fontSize: 14,
                  }}
                  name="reserveFundForRepairs"
                  maxLength={7}
                  min={0}
                  rules={itemRules.reserveFundForRepairs}
                  label="修繕積立費（支出）"
                />
              </div>
            </div>
            <div className="simulate-form-item">
              <div className="simulate-form-input">
                <InputAllowNumber
                  disabled={true}

                  placeholder="例）1"
                  defaultValue={data?.otherExpenses !== undefined && form.getFieldValue('otherExpenses') !== undefined && String(data.otherExpenses) === replace(form.getFieldValue('otherExpenses')) ? String(data.otherExpenses) : ''}
                  suffix={'円'}
                  label="その他費用（インターネット使用料など）（支出）"
                  style={{
                    width: CONSTANTS.INPUT_WIDTH,
                    height: CONSTANTS.INPUT_HEIGHT,
                    border: CONSTANTS.INPUT_BORDER,
                    color: '#000',
                    fontSize: 14,
                  }}
                  name="otherExpenses"
                  maxLength={7}
                  max={1000000}
                  min={0}
                  rules={itemRules.otherExpenses}
                />
              </div>
            </div>
            <div className="simulate-form-item">
              <div className="simulate-form-input">
                <span>
                  金融機関<span style={{ color: '#EB5757' }}>*</span>
                </span>

                <SelectionDynamic
                  style={{
                    width: CONSTANTS.INPUT_WIDTH,
                  }}
                  icon={<img src={DropdownIcon} alt="dropdown icon" />}
                  options={loanOption}
                  name="loanFinancialInstitutionCode"
                  onChange={onChangeSelect}
                />
              </div>
              <div className="simulate-form-input">
                <InputAllowNumber
                  placeholder={PLACEHOLDER.INTEREST_RATE}
                  suffix={'％'}
                  style={{
                    width: CONSTANTS.INPUT_WIDTH,
                    height: CONSTANTS.INPUT_HEIGHT,
                    border: CONSTANTS.INPUT_BORDER,
                    color: '#000',
                    fontSize: 14,
                  }}
                  name="interestRate"
                  fraction={true}
                  maxLength={4}
                  rules={itemRules.interestRate}
                  disabled={isDisalbleItem}
                  label="金利"
                  defaultValue={form.getFieldValue('interestRate')}
                />
              </div>
            </div>
            <div className="simulate-form-item" style={{ display: 'none' }}>
              <div className="simulate-form-input">
                <InputAllowNumber
                  placeholder={PLACEHOLDER.BUILDING_AGE_STANDARD}
                  suffix={'年'}
                  style={{
                    width: CONSTANTS.INPUT_WIDTH,
                    height: CONSTANTS.INPUT_HEIGHT,
                    border: CONSTANTS.INPUT_BORDER,
                    color: '#000',
                    fontSize: 14,
                  }}
                  name="buildingAge"
                  maxLength={2}
                  max={99}
                  min={0}
                  rules={itemRules.buildingAge}
                  disabled={isDisalbleItem}
                  label="築年数基準"
                  defaultValue={data?.buildingAge}
                />
              </div>
              <div className="simulate-form-input">
                <InputAllowNumber
                  placeholder={PLACEHOLDER.EXPENSE}
                  suffix={'円'}
                  style={{
                    width: CONSTANTS.INPUT_WIDTH,
                    height: CONSTANTS.INPUT_HEIGHT,
                    border: CONSTANTS.INPUT_BORDER,
                    color: '#000',
                    fontSize: 14,
                  }}
                  name="expense"
                  maxLength={7}
                  rules={itemRules.expense}
                  disabled={isDisalbleItem}
                  label="諸経費"
                  defaultValue={data?.expense}
                />
              </div>
            </div>
          </div>


          <div className="simulate-form-item">
            <div
              className="simulate-form-option"
              style={{
                cursor: `${btnDisable ? 'not-allowed' : 'pointer'}`,
                background: `${btnDisable ? '#D0D3D8' : '#fff'}`,
              }}
              onClick={() => {
                !btnDisable ? onSubmit() : undefined;
              }}
            >
              再実行
            </div>
            <Button
              type="primary"
              disabled={btnDisable}
              className="simulate-form-option"
              style={{
                background: '#4BCAE5',
                color: '#fff',
                cursor: `${btnDisable ? 'not-allowed' : 'pointer'}`,
              }}
              onClick={() => {
                !btnDisable ? gotoCu01501() : undefined;
              }}
            >
              購入申込に進む
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default FormSimulateSale;